<app-basic-page>
  <div class="header-left">
    <div class="horizontal-large">
      <div class="vertical">
        <div class="title horizontal">
          <div>
            <app-resume-portrait-name [resume]="resume()"></app-resume-portrait-name>
            &lt;&gt; <img class="portrait-tiny" [src]="sales().portrait" />
            {{ sales().name }}
          </div>
          on {{ sessionTemplate()?.title }}
        </div>
        <div class="horizontal talk-info">
          <div class="timer horizontal" [matTooltip]="'Real / Target Call Duration'">
            <span nz-icon style="font-size: 14px" class="material-symbols-rounded">timer</span>
            <div>
              {{ getConversationMins() }} / {{ sessionTemplate()?.unsafeSubData?.targetCallDuration ?? 30 }} mins
            </div>
          </div>

          <div class="create-time">Created at {{ session()?.createdTime | toLocaleFormat: 'ff' }}</div>
        </div>
      </div>
    </div>
  </div>

  <nz-tabset>
    <nz-tab nzTitle="Coaching Moments">
      <div class="tab-content coaching-moments horizontal-large">
        <div class="vertical-large top">
          @if (recordingFileUrl()) {
            <video #videoElement controls class="video-player">
              <source [src]="recordingFileUrl()" type="video/webm" (error)="handleVideoError()" />
              Your browser does not support the video tag.
            </video>
          } @else {
            <video controls class="video-player">
              <source type="video/webm" />
              Your browser does not support the video tag.
            </video>
          }

          @if (!isPremium()) {
            <app-upgrade-to-premium></app-upgrade-to-premium>
          } @else {
            <div class="timeline-container vertical">
              <div class="horizontal title">
                <img class="portrait-tiny" [src]="sales().portrait" /> {{ sales().name }} (Host)
              </div>

              <div class="timeline-bar">
                @for (range of salesTimeRangeList(); track i; let i = $index) {
                  <app-seller-time-range
                    [session]="session()!"
                    [index]="i"
                    [sessionMessageList]="sessionMessageList()"
                    [range]="range"
                    [leftPx]="calculateLeftPosition(range.startTime)()"
                    [widthPx]="calculateWidth(range.startTime, range.endTime)()"
                  ></app-seller-time-range>
                }
              </div>
            </div>

            <div class="timeline-container vertical">
              <div class="horizontal title">
                <app-resume-portrait-name [resume]="resume()"></app-resume-portrait-name>
              </div>

              <div class="timeline-bar">
                @for (range of customerTimeRangeList(); track i; let i = $index) {
                  <app-customer-time-range
                    [session]="session()!"
                    [index]="i"
                    [sessionMessageList]="sessionMessageList()"
                    [range]="range"
                    [leftPx]="calculateLeftPosition(range.startTime)()"
                    [widthPx]="calculateWidth(range.startTime, range.endTime)()"
                  ></app-customer-time-range>
                }
              </div>
            </div>

            <div class="message-list top">
              <div class="message-body full-width" #chatMessages>
                @for (message of messageList(); track $index; let even = $even) {
                  @if (message) {
                    <div class="message horizontal">
                      <img class="portrait" [src]="even ? sales().portrait : sales().portrait" />
                      <div class="content">{{ message }}</div>
                    </div>
                  }
                }
              </div>
            </div>
          }
        </div>
      </div>
    </nz-tab>
    <nz-tab nzTitle="Score">
      @if (this.isLoadingMethodology()) {
        <div class="tab-content vertical-large">
          <nz-skeleton [nzActive]="true"></nz-skeleton>
        </div>
      } @else {
        <div class="tab-content vertical-large">
          <div class="vertical no-gap">
            <div class="horizontal seperate">
              <h3>Overview</h3>
              <button nz-button nzType="default" nzSize="small" (click)="onRegenerateMethodologyClick()">
                <span nz-icon style="font-size: 16px" class="material-symbols-rounded">refresh</span>
                Rescore
              </button>
            </div>
            <!-- <div class="meeting-bar">
                <div [ngStyle]="{ width: '120px' }" class="customer-talk"></div>
                <div [ngStyle]="{ width: '160px' }" class="sales-talk"></div>
                <div [ngStyle]="{ width: '130px' }" class="customer-talk"></div>
                <div [ngStyle]="{ width: '100px' }" class="sales-talk"></div>
              </div> -->

            <div class="small-score-card-list">
              <div class="vertical no-gap small-card-item">
                <h3>Score</h3>
                <div class="horizontal-large">
                  <div class="status-dot" [ngClass]="cssClassesForScore()"></div>
                  <div class="data">{{ score() }} / 5</div>
                </div>
              </div>

              <div class="vertical no-gap small-card-item" nz-tooltip [nzTooltipTitle]="getTalkListenRatioTooltip()">
                <h3 class="horizontal">
                  Talk-listen Ratio
                  <app-question-button
                    [icon]="'info'"
                    [text]="'The proportion of time spent talking versus listening during a conversation.'"
                  ></app-question-button>
                </h3>
                <div class="horizontal-large">
                  <div class="status-dot" [ngClass]="cssClassesForTalkListenRatio()"></div>
                  <div class="data">{{ talkListenRatio() }}</div>
                </div>
              </div>

              <div class="vertical no-gap small-card-item" nz-tooltip [nzTooltipTitle]="getLongestMonologueTooltip()">
                <h3 class="horizontal">
                  Longest Monologue
                  <app-question-button
                    [icon]="'info'"
                    [text]="'The length of the longest uninterrupted speech by the speaker during a conversation.'"
                  ></app-question-button>
                </h3>
                <div class="horizontal-large">
                  <div class="status-dot" [ngClass]="cssClassesForLongestMonologue()"></div>
                  <div class="data">{{ longestMonologue() }}</div>
                </div>
              </div>

              <div class="vertical no-gap small-card-item" nz-tooltip [nzTooltipTitle]="getFillerWordsTooltip()">
                <h3 class="horizontal">
                  Filler words
                  <app-question-button
                    [icon]="'info'"
                    [text]="'Words like “um,” “uh,” “like,” and “you know” used to fill gaps in speech.'"
                  ></app-question-button>
                </h3>
                <div class="horizontal-large">
                  <div class="status-dot" [ngClass]="cssClassesForFillerWords()"></div>
                  <div class="data">{{ fillerWordsPerMin() }} words/min</div>
                </div>
              </div>

              <div class="vertical no-gap small-card-item" nz-tooltip [nzTooltipTitle]="getTalkSpeedTooltip()">
                <h3 class="horizontal">
                  Talk speed
                  <app-question-button
                    [icon]="'info'"
                    [text]="
                      'The rate at which a speaker delivers their speech, typically measured in words per minute (WPM).'
                    "
                  ></app-question-button>
                </h3>
                <div class="horizontal-large">
                  <div class="status-dot" [ngClass]="cssClassesForTalkSpeed()"></div>
                  <div class="data">{{ talkSpeedPerMin() }} words/min</div>
                </div>
              </div>
            </div>
          </div>

          <div class="vertical no-gap">
            <h3>Video Overview</h3>
            <div class="small-score-card-list">
              <div class="vertical no-gap small-card-item">
                <h3 class="horizontal">
                  <span>🙂 Engagement </span>
                  <app-question-button
                    [icon]="'info'"
                    [text]="'Eye contacts to the camera, smiling, nodding, reacting to AI customers, etc'"
                  ></app-question-button>
                </h3>
                <div class="horizontal-large">
                  <div class="status-dot" [ngClass]="'status-dot-good'"></div>
                  <div class="data">Coming Soon</div>
                </div>
              </div>

              <div class="vertical no-gap small-card-item">
                <h3 class="horizontal">
                  🎥 Visual Impressions
                  <app-question-button
                    [icon]="'info'"
                    [text]="'Not looking around, good lightings, look at screens, background, looks, dressings, etc.'"
                  ></app-question-button>
                </h3>
                <div class="horizontal-large">
                  <div class="status-dot" [ngClass]="'status-dot-good'"></div>
                  <div class="data">Coming Soon</div>
                </div>
              </div>

              <div class="vertical no-gap small-card-item">
                <h3 class="horizontal">
                  🎭 Audience Attention
                  <app-question-button
                    [icon]="'info'"
                    [text]="'Confident, smiling, speak with emphasis, pauses.'"
                  ></app-question-button>
                </h3>
                <div class="horizontal-large">
                  <div class="status-dot" [ngClass]="'status-dot-good'"></div>
                  <div class="data">Coming Soon</div>
                </div>
              </div>
            </div>
          </div>

          <div class="vertical no-gap">
            <h3 class="horizontal">
              <div>Methodology Overview</div>
              <button
                nz-button
                nzType="text"
                nzSize="small"
                [matTooltip]="'See Methodology Details'"
                (click)="onMethodologyDetailsClick()"
              >
                <span nz-icon style="font-size: 16px" class="material-symbols-rounded">info</span>
              </button>
            </h3>
            <div
              class="methodology-details-recessed"
              [@detailsExpand]="isMethodologyDetailsVisible ? 'expanded' : 'collapsed'"
            >
              <div
                [ngStyle]="{ padding: '10px' }"
                [innerHTML]="session()?.subData?.methodology?.description | markdownIt"
              ></div>
            </div>
            <div class="methodology-content">
              <app-bar-chart
                [view]="[600, 500]"
                [yScaleMax]="5"
                [yAxisLabel]="'Score'"
                [dataList]="chartDataList()"
                (onSelect)="onMethodologyContentSelect($event)"
              ></app-bar-chart>
              <div class="vertical-large reason">
                <div class="block">
                  <h3>Performance Criteria</h3>
                  <div class="vertical">
                    {{ this.selectedMethodologyCriteria()?.criterion }}
                    @if (this.selectedMethodologyCriteria()?.criterion !== 'Overall') {
                      <button
                        class="fit-content"
                        nz-button
                        nzType="default"
                        nzSize="small"
                        (click)="onBackToOverallClick()"
                      >
                        <span nz-icon style="font-size: 16px" class="material-symbols-rounded">undo</span>
                        Back to Overall
                      </button>
                    }
                  </div>
                </div>
                <div class="block">
                  <h3>Score</h3>
                  <div>{{ this.selectedMethodologyCriteria()?.rating }} / 5</div>
                </div>
                <div class="block">
                  <h3>Reason</h3>
                  <div>
                    {{ this.selectedMethodologyCriteria()?.reason }}
                  </div>
                </div>
                <div class="block">
                  <h3>How to Improve</h3>
                  <div>
                    {{ this.selectedMethodologyCriteria()?.improvements }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </nz-tab>
    <nz-tab nzTitle="Feedback">
      <div class="tab-content vertical-large report-content">
        <div class="summary">
          <div class="horizontal seperate">
            <h3>Summary</h3>
            <button nz-button nzType="default" nzSize="small" (click)="onRegenerateGoalAndSessionSummaryClick()">
              <span nz-icon style="font-size: 16px" class="material-symbols-rounded">refresh</span>
              Regenerate
            </button>
          </div>
          <div class="summary-content">
            @if (isLoadingSummary()) {
              <nz-skeleton [nzActive]="true"></nz-skeleton>
            } @else {
              {{ summary() }}
            }
          </div>
        </div>

        <div class="vertical no-gap">
          <h3>Goal Achievement</h3>

          @if (isLoadingGoal()) {
            <nz-skeleton [nzActive]="true"></nz-skeleton>
          } @else {
            <div class="goal-content" [innerHTML]="goalEvaluation() ?? '' | markdownIt"></div>
          }
        </div>
      </div>
    </nz-tab>

    <nz-tab nzTitle="Objection Handling">
      <div class="tab-content vertical-large">
        <app-objection-handling-table
          [sessionMessageList]="sessionMessageList()"
          [emotionalObjectionList]="emotionalObjectionList()"
          [factObjectionList]="factObjectionList()"
        ></app-objection-handling-table>
        <!-- <button
          class="fit-content"
          nz-button
          nzType="default"
          nzSize="small"
          (click)="onGenerateObjectionHandlingClick()"
        >
          <span nz-icon style="font-size: 16px" class="material-symbols-rounded">auto_awesome</span>
          Evaluate Objection Handling
        </button>

        @if (isLoadingObjectionHandlingEvaluation()) {
          <nz-skeleton [nzActive]="true"></nz-skeleton>
        } @else {
          <app-markdown-it
            class="objection-handling-table"
            [markdown]="objectionHandlingEvaluation()"
          ></app-markdown-it>
        } -->
      </div>
    </nz-tab>

    <nz-tab nzTitle="Scenario">
      @if (session()) {
        <div class="tab-content">
          <nz-collapse>
            <nz-collapse-panel [nzHeader]="'Product'" [nzActive]="true">
              <div class="vertical no-gap">
                <h3>{{ session()?.subData?.product?.title }}</h3>
                <div
                  class="product-section"
                  [innerHTML]="session()?.subData?.product?.description ?? '' | markdownIt"
                ></div>
              </div>
            </nz-collapse-panel>

            <nz-collapse-panel [nzHeader]="'Goal'" [nzActive]="true">
              <div class="vertical no-gap">
                <h3>{{ session()?.subData?.goal?.title }}</h3>
                <div class="goal-section" [innerHTML]="session()?.subData?.goal?.description ?? '' | markdownIt"></div>
              </div>
            </nz-collapse-panel>

            <nz-collapse-panel [nzHeader]="'Methodology'" [nzActive]="true">
              <h3>{{ session()?.subData?.methodology?.title }}</h3>
              <div
                class="methodology-section"
                [innerHTML]="session()?.subData?.methodology?.description ?? '' | markdownIt"
              ></div>
            </nz-collapse-panel>
          </nz-collapse>
        </div>
      }
    </nz-tab>
  </nz-tabset>
</app-basic-page>
